<template>
  <div id="J_chartBarBox" class="chart-box"></div>
</template>

<script>

import {
  getOrderanalysisweeklydata
} from "@/request/requests";
import {
  isEmpty
} from "@/util/util"
export default {
  name: "barChart",
  data() {
    return {
      chartBar: null,
      maxVal:'',
      maxIndex:''
    }
  },
  methods: {
    async getData() {
      let dataList = [];
      let data = {
        starttime: this.getLastWeekDateRange().startDate,
        endtime:this.getLastWeekDateRange().endDate
      }
      let res = await getOrderanalysisweeklydata(data);
      if (res.status == "200") {
        let list = res.data;
        if(!isEmpty(list)){
          list.forEach((item,index)=>{
            dataList.push(item.data)
          })
        }
      }
      this.maxVal = Math.max.apply(null, dataList);
      this.maxIndex = dataList.indexOf(Math.max(...dataList));
      dataList.splice(this.maxIndex,1,{
        value:this.maxVal,
        itemStyle:{
          color:'#FAC958'
        }
      })
      this.initChartBar(dataList);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需要加 1
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // 获取近一周的日期范围
    getLastWeekDateRange() {
      const endDate = new Date(); // 当前日期
      const startDate = new Date();
      startDate.setDate(endDate.getDate() - 7); // 一周前的日期
      return {
        startDate: this.formatDate(startDate),
        endDate: this.formatDate(endDate),
      };
    },
    initChartBar(dataList) {
      let option = {
        tooltip: {
          // 触发类型，默认数据触发，可选为：'item' | 'axis'
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisLabel:{
            show:true,
            interval:0
          }
        },
        yAxis: {
          type: 'value'
        },
        legend: {
          //销量
          data:[this.$t('friends.salesvolume')]
        },
        series: [
          {
            //销量
            name: this.$t('friends.salesvolume'),
            data: dataList,
            itemStyle: {
              color: '#91CC78'
            },
            type: 'bar',
            barWidth: '50%',
          }
        ]
      };
      this.chartCircle = this.$echarts.init(document.getElementById('J_chartBarBox'))
      this.chartCircle.setOption(option);
      window.addEventListener('resize', () => {
        this.chartCircle.resize()
      })
    }

  },
  mounted() {
    this.getData();
  }
}
</script>

<style lang="scss" scoped>

</style>